export default __webpack_public_path__ + "static/media/10_photo.34864894.jpg";